import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays a product SKU.
 * Listens for variant update events and updates the SKU display accordingly.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the SKU display when a variant is selected.
   * Prefers the fully-rendered Liquid output from the fetched HTML fragment
   * (which includes the label) over the raw variant object.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateSku = (event) => {
    const variant = event.detail.resource;

    // Non-existent variant permutation — no variant object at all
    if (!variant) {
      this.hidden = false;
      this.style.opacity = '0.3';
      this.textContent = 'ITEM UNAVAILABLE';
      return;
    }

    this.hidden = false;
    this.style.opacity = '';

    // Prefer the fully-rendered Liquid output (label + SKU already formatted).
    // Falls back to constructing from the raw variant object when the fetched
    // fragment is absent (e.g. sold-out variant selected).
    const newSkuEl = event.detail.data.html?.querySelector('product-sku');
    if (newSkuEl && newSkuEl.innerHTML.trim() !== '') {
      this.innerHTML = newSkuEl.innerHTML;
    } else {
      const sku = variant.sku;
      const label = this.dataset.label ?? '';
      this.textContent = sku
        ? (label ? `${label} ${sku}` : sku)
        : 'ITEM UNAVAILABLE';
      if (!sku) this.style.opacity = '0.3';
    }
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
